export default {
  title: 'Drukowany paragon',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Ukryj opłatę serwisową na paragonie',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Ukryj sekcję cen na paragonie',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Ukryj nazwy grup modyfikatorów na paragonie',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
